module.exports = __webpack_public_path__ + "static/media/mcm5.6c50fdf9.PNG";